/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Drift_Step_0Inputs */

const en_landing_drift_step_0 = /** @type {(inputs: Landing_Drift_Step_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Original`)
};

const zh_landing_drift_step_0 = /** @type {(inputs: Landing_Drift_Step_0Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`原图`)
};

/**
* | output |
* | --- |
* | "Original" |
*
* @param {Landing_Drift_Step_0Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_drift_step_0 = /** @type {((inputs?: Landing_Drift_Step_0Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Drift_Step_0Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_drift_step_0(inputs)
	return zh_landing_drift_step_0(inputs)
});
export { landing_drift_step_0 as "landing.drift.step_0" }